import styled from 'styled-components';

const Button = styled.button`
  padding: 8px 25px;
  width: 100%;
  margin-right: 0;
  font-family: 'InterSemiBold';
  font-size: 20px;
  background-color: #0a578b;
  border: 2px solid #0a578b;
  color: #FFFFFF;
`;

export default Button;
